import chunk from "lodash/chunk";
import { LegacyGetProfilesCollection } from "PFApp/legacy_cv_export_flow";
import { fetchExportProfiles } from "PFCore/services/export_profiles";
import { Id } from "PFTypes";

import { ComparableProfile } from "../details/parts/use_cell_data";

// Legacy CV export flow copied from uat, used only when the cv_export_legacy_flow feature flag is ON.
// Meant to be removed together with the flag.
export const getLegacyCvExportProfilesCollection = (
  comparableProfiles: ComparableProfile[],
  activityId: Id
) =>
  ((paginationPage = 1, paginationSize = 50) => {
    const items = comparableProfiles.map(({ profile }) => profile);

    const paginatedArray = chunk(items, paginationSize);
    return fetchExportProfiles({
      profileIds: paginatedArray[paginationPage - 1].map(({ id }) => id),
      activityId
    }).then((resp) => ({
      entries: resp.map((profile) => ({
        profile
      })),
      meta: { total: items.length, page: paginationPage }
    }));
  }) as LegacyGetProfilesCollection;
